import { getTimeRemaining, checkIsPastTimestamp } from '../../utils';
import Icon from '../../components/icons';

const hotIcon = Icon({ type: 'hot', color: '#323945', size: 12 });
const wallClockIcon = Icon({ type: 'wall_clock', color: '#323945', size: 12 });

class OfferHeader {
  constructor(getText) {
    this.getText = getText;
    this.container = document.createElement('div');
    this.container.setAttribute('id', 'js-schedule-offer-offerwall');
    this.rewardOfferEnabled = Pollfish.helper.json.reward_offer_enabled;
    this.rewardOfferMultiplier = Pollfish.helper.json.reward_offer_multiplier;
    this.rewardOfferExpiration = Pollfish.helper.json.reward_offer_expiration;
  }

  startOfferCountdown = (callback) => {
    const {
      reward_offer_expiration: rewardOfferExpiration,
    } = Pollfish.helper.json;

    let time = getTimeRemaining(rewardOfferExpiration);
    let timeLeft = time.total;
    this.timer = setInterval(() => {
      time = getTimeRemaining(rewardOfferExpiration);
      const offerwallBanner = $('#js-schedule-offer-offerwall');
      timeLeft = time.total;
      if (timeLeft < 0 || offerwallBanner.length === 0) {
        if (callback && typeof callback === 'function') {
          callback();
        }
        this.clearTimer();
      }
      this.render();
    }, 1000);
  };

  clearTimer = () => {
    clearInterval(this.timer);
  };

  hide = () => {
    this.clearTimer();
    this.container.innerHTML = '';
  };

  render() {
    const {
      rewardOfferEnabled,
      rewardOfferMultiplier,
      rewardOfferExpiration,
    } = this;
    const isOfferExpired = checkIsPastTimestamp(rewardOfferExpiration);

    if (
      !rewardOfferEnabled ||
      !rewardOfferMultiplier ||
      !rewardOfferExpiration ||
      isOfferExpired
    ) {
      this.container.innerHTML = '';
      return this.container;
    }
    const { text } = getTimeRemaining(rewardOfferExpiration);
    const { getText } = this;
    this.container.innerHTML = `
      <div style="background-color: #ffdc4d; color: #323945;">
        <div class="flex padding-sm container">
          <section class="flex flex-1 container flex-align-items--center flex-wrap" style="margin: -4px 0;">
            <div class="flex flex-1 flex-align-items--center" style="margin: 4px 0;">
              <span class="line-height-reset" style="margin-bottom: 2px;">${hotIcon}</span>
              <span class="text-sm font-bold line-height-reset" style="margin-left: 3px; white-space: nowrap;">${rewardOfferMultiplier}x ${getText(
      'schedule_offer.rewards',
    )}</span>
            </div>
            <div class="flex flex-align-items--center" style="margin: 4px 0;">
              <span class="line-height-reset" style="margin-bottom: 2px;">${wallClockIcon}</span>
              <span class="text-sm line-height-reset" style="margin-left: 8px; white-space: nowrap;">${getText(
                'schedule_offer.offer_ends',
              )}:</span>
              <span class="text-sm font-bold line-height-reset" style="margin-left: 6px; white-space: nowrap;">${text}</span>
            </div>
          </section>
        </div>
      </div>
    `;

    return this.container;
  }
}

export default OfferHeader;
